const apiKey = 'AIzaSyD1PH9SNO1oksgAag1iJwzPFNMWz2L2OqM';
export const FETCH_GEOCODE_API = `https://maps.googleapis.com/maps/api/geocode/json?key=${apiKey}&sensor=false&address=$address`;

const toDay = new Date();
const timestamp = Math.round(toDay.getTime() / 1000);
export const FETCH_TIMEZONE_API = `https://maps.googleapis.com/maps/api/timezone/json?location=$address&timestamp=${timestamp}&key=${apiKey}`;
